// extracted by mini-css-extract-plugin
module.exports = {"root":"Panel-module__root___qxCux","show":"Panel-module__show___JxLwG","action":"Panel-module__action___29pZE"};